import CrudCustom from '../../../libs/custom/CrudCustom';

let PajakTerutangAkunPphService = new CrudCustom('/detail-akun-pphs');
export default PajakTerutangAkunPphService;
